import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AbaFilterContent } from '../../../../components/develop-nilton-components/AbaFiltro';
import { AbaProgress } from '../../../../components/develop-nilton-components/AbaProgress';
import { SectionHeader } from '../../../../components/SectionHeader';
import { SpinnerLoading } from '../../../../components/SpinnerLoading';
import api from '../../../../services/api';
import { SocioEco } from './SocioEco';
import { AspectosSocias } from './AspectosSociais';
import { Observacao } from './Observacao';
import { Queixa } from './Queixa';

export function PageFormAssistenteSocial() {
  const [tab, setTab] = useState(1);
  const { state } = useLocation<any>();
  const history = useHistory();
  const [load, setLoad] = useState(false);

  const [acompanhemento, set_acompanhamento] = useState<any>(null);

  const { getValues, setValue } = useForm({ defaultValues: acompanhemento });

  async function handleCancelar() {
    setLoad(true);
    try {
      const { data } = await api.delete(`/social/${getValues().id}`);
      history.push('/acompanhamento');
      toast.success(data.message);
    } catch (error) {
      // @ts-ignore
      toast.error(error.response.data.message);
    }
    setLoad(false);
  }

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.post('/social', { egress_id: state.id });
        const keys = Object.keys(data);
        keys.forEach((key) => {
          setValue(key, data[key]);
        });

        set_acompanhamento(data);
      } catch (error) {
        // @ts-ignore
        const errors = error.response.data.acompanhamento;
        const keys = Object.keys(errors);
        keys.forEach((key) => {
          setValue(key, errors[key]);
        });
        set_acompanhamento(errors);
      }
    })();
  }, []);

  return (
    <div className="w-100" data-testid="page_consulta">
      <SectionHeader subtitle="Assistente Social" backPage="/acompanhamento" />

      {!getValues().id && (
        <div className="d-flex justify-content-center m-5">
          <SpinnerLoading />
        </div>
      )}

      {getValues().egress_id && (
        <div>
          <p className="text-primary h2">{`Nome: ${state.nome}`}</p>
          <div className="d-flex justify-content-between mb-2" style={{ width: "100%" }}>
            <AbaProgress
              abas={[
                'Aspectos Sociais',
                'Socio-Econômicos',
                'Queixa',
                'Observações',
              ]}
              useStateTab={[tab, setTab]}
              size="medium"
            />
            {!load ? (
              <button
                className="btn btn-danger m-1"
                onClick={handleCancelar}
              >
                Cancelar
              </button>
            ) : (
              <button
                className="btn btn-danger m-1"
              >
                <SpinnerLoading />
              </button>
            )}
          </div>

          <AbaFilterContent
            tab={tab}
            components={[
              <AspectosSocias
                getValues={getValues}
                setValue={setValue}
                setTab={setTab}
              />,
              <SocioEco
                getValues={getValues}
                setValue={setValue}
                setTab={setTab}
              />,
              <Queixa
                getValues={getValues}
                setValue={setValue}
                setTab={setTab}
              />,
              <Observacao
                getValues={getValues}
                setValue={setValue}
                setTab={setTab}
              />,
            ]}
          />
        </div>
      )}

    </div>
  );
}
